import { Tooltip } from '@betterment/samba-react';

export const ProjectedBalanceTooltip = () => (
  <Tooltip>
    <Tooltip.Trigger asChild={true}>
      <Tooltip.IconButton name="InfoCircle" />
    </Tooltip.Trigger>
    <Tooltip.Content>
      Your projected balance factors in deposits, transfers, expected dividends, pending fee payments, and any linked
      external accounts related to this goal. Cash Reserve projections incorporate market expectations of future
      interest rate changes.
    </Tooltip.Content>
  </Tooltip>
);
